import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserService } from '../services/user.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss',
  standalone: true,
  imports: [RouterModule, CommonModule]
})
export class MainMenuComponent implements OnInit {
  public isCurrentUserAdmin: boolean = false;

  constructor(
    private readonly userService: UserService
  ) {}

  async ngOnInit() {
    this.userService.userRole$.subscribe(role => {
      if (role === 'Admin') {
        this.isCurrentUserAdmin = true;
      }
    });
  }
  isCollapsed = false;
}

